/**
 * Parse YYYY-MM-DDTHH:mm:ss as wall-clock time in America/Los_Angeles (PST/PDT).
 */
(function () {
  function partValue(parts, type) {
    var part = parts.find(function (p) {
      return p.type === type;
    });
    return part ? Number(part.value) : 0;
  }

  function laParts(formatter, t) {
    var parts = formatter.formatToParts(new Date(t));
    return {
      y: partValue(parts, 'year'),
      mo: partValue(parts, 'month'),
      d: partValue(parts, 'day'),
      h: partValue(parts, 'hour') % 24,
      mi: partValue(parts, 'minute'),
      s: partValue(parts, 'second'),
    };
  }

  function parsePacificTargetMs(isoLocal) {
    var cleaned = String(isoLocal)
      .trim()
      .replace(/(Z|[+-]\d{2}:\d{2})$/i, '');
    var m = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!m) return NaN;

    var y = +m[1];
    var mo = +m[2];
    var d = +m[3];
    var h = +(m[4] || 0);
    var mi = +(m[5] || 0);
    var s = +(m[6] || 0);

    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    var utcGuess = Date.UTC(y, mo - 1, d, h, mi, s);

    for (var i = 0; i < 3; i++) {
      var got = laParts(fmt, utcGuess);
      var diff =
        Date.UTC(y, mo - 1, d, h, mi, s) -
        Date.UTC(got.y, got.mo - 1, got.d, got.h, got.mi, got.s);
      if (diff === 0) break;
      utcGuess += diff;
    }

    return utcGuess;
  }

  window.parsePacificTargetMs = parsePacificTargetMs;
})();
